import searchForUserQuestions from 'src/graphql/queries/searchForUserQuestions';

import post from './shared/post';

export default {
  searchForUserQuestions(values) {
    return post(values, searchForUserQuestions);
  },
};
